import { merge } from 'lodash';
import { createAndResetOnLogout } from 'stores/utils';

import { persist } from 'zustand/middleware';
import { ResidentDetailsTypes } from '../../types/resident-details-types';

interface ResidentDetailsStore {
  residentDetails: ResidentDetailsTypes | undefined;
  setResidentDetails: (residentDetails: ResidentDetailsTypes) => void;
  setAutopay: (newValue: boolean) => void;
}

const useResidentDetailsStore = createAndResetOnLogout<ResidentDetailsStore>()(
  persist(
    (set) => ({
      residentDetails: undefined,
      setResidentDetails: (newResidentDetails) => {
        set(({ residentDetails }) => ({
          residentDetails: merge(residentDetails, newResidentDetails),
        }));
      },
      setAutopay: (newValue: boolean) => {
        set((state) => {
          if (!state.residentDetails) return state;
          return {
            ...state,
            residentDetails: {
              ...state.residentDetails,
              isAutoPayEnabled: newValue,
            },
          };
        });
      },
    }),
    { name: 'resident' }
  )
);

export default useResidentDetailsStore;
